import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface GroupedFlowSectionState {
    folded: boolean;
}

const initialState: GroupedFlowSectionState = {
    folded: false,
};

const flowSettingsSlice = createSlice({
    name: 'flow-settings',
    initialState: initialState,
    reducers: {
        setFolded: (state, action: PayloadAction<boolean>) => {
            state.folded = action.payload;
        },
    },
});

export const { setFolded } = flowSettingsSlice.actions;

export default flowSettingsSlice.reducer;
